import { RoleTypes } from '../models';

export function isRequiredRole(role: RoleTypes, requiredRoles?: RoleTypes[]) {
	return (
		role === RoleTypes.SUPER_ADMIN ||
		(requiredRoles && requiredRoles.length
			? requiredRoles.includes(role)
			: true)
	);
}
